export default __webpack_public_path__ + "static/cruiselines-vrc-ship-5-39494645d0a8bb5079478d8058bfacdf.jpg";